/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Settings_DescriptionInputs */



/**
* | output |
* | --- |
* | "Manage your account and how the portal looks." |
*
* @param {Partner_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_settings_description = /** @type {((inputs?: Partner_Settings_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Settings_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie Ihr Konto und die Darstellung des Portals.")
	return /** @type {LocalizedString} */ ("Manage your account and how the portal looks.")
});